import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './Wallet.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { LocalStorageService } from '@/services/LocalStorageService';
import { IInitiatePaymentResponseDto } from '@/Dtos/InitiatePaymentResponseDto';
import { PaymentDto } from '../../Dtos/PaymentDto';
import { PaymentGateWay } from '@/types/CartTypes';
import shoppingCart from '@/store/modules/shoppingCart'
import _axios from '@/services/axios';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  ...mapGetters("shoppingCart",
  { payment: "getPaymentGateWayDto" }),
  components: {
    Loading,
  },
})
export default class Wallet extends Vue {
   balance=0;
   currency:String="";
   payment!:PaymentGateWay;
   paymentDto: PaymentDto = {} as PaymentDto;
   isLoading = true; 

   constructor()
   {
    super();
    let localStorageService = new LocalStorageService();
    let paymentDetails = localStorageService.get('paymentDetails');
    if( paymentDetails ===null || paymentDetails ==="")
     this.$router.push("products");
    this.payment =  JSON.parse(paymentDetails);
   }

   mounted () {
  this.getCreditBalance();
  }

  getCreditBalance():void
  {
    this.isLoading = true; 
    _axios.get(config.credits+"Currency=R")
    .then(response=>
    {
      this.balance=response.data.balance;
      this.currency=response.data.currency;
    })
    .catch(err=>{console.error(err);})
    .finally(()=>{
      this.isLoading = false;
    });
  }

  makePayment():void
  {
    this.paymentDto.Amount=this.payment.totalAmount;
    this.paymentDto.Currency="R";
    this.paymentDto.Description=this.payment.itemDescription;
    this.paymentDto.ItemName=this.payment.itemName;
    this.paymentDto.ReferenceId=this.payment.mPaymentId;
    this.paymentDto.Signature=this.payment.signature;
    this.isLoading = true; 

    _axios.post(config.walletWithdrawal,this.paymentDto)
    .then(response=>
    {
      console.log("done processing payement");
      window.location.href = "/callback?page=success";
    })
    .catch(err=>{console.error(err);});
  }

  get AllowPayment():boolean{
    let check=this.balance - this.payment.totalAmount;
    return check >= 0;
  }
}
